// AI 診斷手冊（學習所得與手動建立的診斷流程）— React Admin 資源字串。
export const aiPlaybooks = {
  name: '診斷手冊 |||| 診斷手冊',
  fields: {
    id: 'ID',
    name: '名稱',
    description: '說明',
    symptomKeywords: '徵狀關鍵字',
    symptomExamples: '徵狀範例',
    keyword: '關鍵字',
    example: '範例',
    triggerConditions: '觸發條件（JSON）',
    diagnosticSteps: '診斷步驟（JSON）',
    rootCauseCategory: '根本原因類別',
    remediationGuidance: '修復指引',
    isActive: '啟用',
    source: '來源',
    learned: '學習所得',
    manual: '手動建立',
    createdFromInvestigationId: '來源調查',
    createdBy: '建立者',
    createdAt: '建立時間',
    updatedAt: '更新時間',
  },
  sections: {
    identity: '基本資料',
    symptoms: '徵狀',
    remediation: '修復',
    diagnostics: '診斷',
  },
  categories: {
    none: '（無）',
    software_bug: '軟體錯誤',
    hardware_fault: '硬體故障',
    firmware_issue: '韌體問題',
    config: '設定問題',
    user_error: '使用者操作錯誤',
    network: '網路問題',
    unknown: '無法判定',
  },
  filters: {
    isActive: '狀態',
    active: '啟用',
    inactive: '停用',
  },
  list: {
    title: '診斷手冊',
  },
  create: {
    title: '建立診斷手冊',
    subtitle: '手動建立診斷手冊',
    backToList: '返回診斷手冊列表',
  },
  edit: {
    title: '編輯診斷手冊',
    subtitle: '調整此診斷手冊',
    backToList: '返回診斷手冊列表',
  },
  show: {
    emptyJson: '無',
    emptyArray: '無',
    manualOrigin: '手動建立（無來源調查）',
  },
  helpers: {
    rootCauseCategory: '選填。若尚未確定類別，可留空。',
    isActive: '已啟用的診斷手冊會用於比對新的調查。',
    symptomKeywords: '用於將徵狀比對至此手冊的關鍵字，至少需要一個。',
    symptomExamples: '用於模型輔助比對的徵狀描述範例。',
    remediationGuidance: '供人員參考的問題修復指引。',
    diagnosticSteps:
      '依序排列的 JSON 步驟陣列，每個步驟需包含 tool、params_template、check 與 on_match。',
    triggerConditions: '選填的結構化前置條件 JSON 物件。',
  },
  errors: {
    invalidJson: 'JSON 格式無效，請先修正語法再儲存。',
  },
  promote: {
    button: '提升為診斷手冊',
    success: '調查已提升，請於下方調整新的診斷手冊。',
    error: '無法將此調查提升為診斷手冊。',
    errorNotFound: '該調查已不存在，或不在您的可檢視範圍內。',
    errorNotPromotable: '此調查無法提升（已提升或尚未完成）。',
    errorPermission: '您沒有提升調查的權限。',
    disabledRefused: '已拒絕的調查無法提升。',
    disabledFailed: '失敗的調查無法提升。',
    disabledRunning: '請等待調查完成後再提升。',
    disabledGeneric: '只有已完成的調查才能提升。',
  },
  notifications: {
    created: '診斷手冊已成功建立。',
    updated: '診斷手冊已成功更新。',
    deleted: '診斷手冊已成功刪除。',
    error: {
      create: '建立診斷手冊失敗。',
      update: '更新診斷手冊失敗。',
      delete: '刪除診斷手冊失敗。',
    },
  },
};
